<script setup lang="ts">
import { useImage } from '@vueuse/core';

interface IProps {
    urlFallback: string;
    small?: boolean;
    desktopSmall?: boolean;
    mobileView?: boolean;
    url: string;
    title: string;
}
const { url, urlFallback, mobileView, small, desktopSmall, title } =
    defineProps<IProps>();
const { isLoading, error } = useImage({ src: url });
const alt = computed(() => `لوگوی ${title}`);
</script>

<template>
    <mr-loading
        v-if="isLoading"
        class="loading"
        :class="{
            small,
            'desktop-small': desktopSmall,
            'mobile-view': mobileView,
        }"
    />
    <img
        v-else
        class="logo-image"
        :class="{
            small,
            'desktop-small': desktopSmall,
            'mobile-view': mobileView,
        }"
        :src="error ? urlFallback : url"
        :alt
        v-bind="$attrs"
    />
</template>

<style lang="scss" scoped>
@mixin mobile-view {
    width: 32px;
    height: 32px;
    &.small {
        width: 28px;
        height: 28px;
    }
    &.desktop-small {
        width: 28px;
        height: 28px;
    }
}

.logo-image,
.loading {
    object-fit: contain;
    width: 40px;
    height: 40px;
    &.mobile-view {
        @include mobile-view();
    }
    @include mobile-only() {
        @include mobile-view();
    }
    &.small {
        width: 36px;
        height: 36px;
    }
    &.desktop-small {
        width: 28px;
        height: 28px;
    }
}
</style>
